import React from 'react';

import { OverlayContext } from './OverlayContext';

export const useOverlayContext = () => React.useContext(OverlayContext);
